// Barkod / QR üretimi — hem tasarım önizlemesi hem yazdırma için SENKRON HTML döndürür.
// printRenderer yazdırma penceresine statik HTML yazdığından, barkodlar ana pencere
// bağlamında (document.createElement / QRCode.create ile) önceden render edilir.
import JsBarcode from 'jsbarcode';
import QRCode from 'qrcode';

export const BARCODE_FORMATS = [
  { value: 'CODE128', label: 'Code 128 (genel)' },
  { value: 'EAN13', label: 'EAN-13 (13 hane)' },
  { value: 'CODE39', label: 'Code 39' },
  { value: 'ITF14', label: 'ITF-14 (14 hane)' },
  { value: 'QR', label: 'QR Kod' },
];

// QR matrisini senkron üretip ölçeklenebilir SVG string döner.
function qrSvg(value) {
  const qr = QRCode.create(value || ' ', { errorCorrectionLevel: 'M' });
  const n = qr.modules.size;
  const data = qr.modules.data;
  let rects = '';
  for (let r = 0; r < n; r += 1) {
    for (let c = 0; c < n; c += 1) {
      if (data[r * n + c]) rects += `<rect x="${c}" y="${r}" width="1" height="1"/>`;
    }
  }
  return `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 ${n} ${n}" preserveAspectRatio="xMidYMid meet" `
    + `style="width:100%;height:100%;display:block" shape-rendering="crispEdges">`
    + `<rect width="${n}" height="${n}" fill="#fff"/><g fill="#000">${rects}</g></svg>`;
}

function barcode1dDataUrl(value, format, showText) {
  const canvas = document.createElement('canvas');
  JsBarcode(canvas, value, {
    format, displayValue: !!showText, margin: 0, height: 80, fontSize: 18, width: 2,
  });
  return canvas.toDataURL('image/png');
}

// value/format → barkodun iç HTML'i (img veya inline svg), kapsayıcıyı %100 doldurur.
export function barcodeHtml(value, format = 'CODE128', showText = false) {
  const v = value === null || value === undefined ? '' : String(value);
  try {
    if (format === 'QR') return qrSvg(v || ' ');
    const url = barcode1dDataUrl(v || '0', format, showText);
    return `<img src="${url}" style="width:100%;height:100%;display:block" alt="barcode"/>`;
  } catch (e) {
    // Geçersiz değer (ör. EAN-13 hane sayısı) → CODE128'e düş, o da olmazsa metin göster.
    try {
      const url = barcode1dDataUrl(v || '0', 'CODE128', showText);
      return `<img src="${url}" style="width:100%;height:100%;display:block" alt="barcode"/>`;
    } catch (_) {
      return `<div style="font-size:8pt;color:#b91c1c;font-family:sans-serif">Barkod hatası</div>`;
    }
  }
}
